import React from "react";
import styles from './index.module.scss'

const Lifestyle = () => {

    const lifestyle = {
        alcohol: "Moderate",
        exercise: "Regular",
        sleep: "7-8 hours",
        smoke: "No",
        travel: "Occasional"
    };

    const preexsitingconditons = [
        {
            condition: "Hypertension",
            self: "Yes",
            family: "No"
        },
        {
            condition: "Diabetes",
            self: "No",
            family: "Yes"
        },
        // Add more pre-existing conditions here as needed
    ];
  return (
    <div className={styles.subContainerRow}>
      <div className={styles.amTableContainer}>
        <div className={styles.title}>Lifestyle</div>

        <table className={styles.lifestyleTable}>
          <tr>
            <th colSpan={2}>Conditions</th>
          </tr>

          {lifestyle != null ? (
            <tbody>
              <tr>
                <td>Alcohol</td>

                <td>
                  {lifestyle.alcohol != "" && lifestyle.alcohol != undefined
                    ? lifestyle.alcohol
                    : "NA"}
                </td>
              </tr>

              <tr>
                <td>Exercise</td>

                <td>
                  {lifestyle.exercise != "" && lifestyle.exercise != undefined
                    ? lifestyle.exercise
                    : "NA"}
                </td>
              </tr>

              <tr>
                <td>Sleep</td>

                <td>
                  {lifestyle.sleep != "" && lifestyle.sleep != undefined
                    ? lifestyle.sleep
                    : "NA"}
                </td>
              </tr>
              <tr>
                <td>Smoke</td>

                <td>
                  {lifestyle.smoke != "" && lifestyle.smoke != undefined
                    ? lifestyle.smoke
                    : "NA"}
                </td>
              </tr>
              <tr>
                <td>Travel</td>

                <td>
                  {lifestyle.travel != "" && lifestyle.travel != undefined
                    ? lifestyle.travel
                    : "NA"}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    background: "#fcfcfc",
                    borderBottom: "1px solid #E8EBED;",
                  }}
                >
                  <div className="no-data">
                    <span>No data available</span>
                  </div>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>

      <div className={styles.amTableContainer}>
        <div className={styles.title}> Pre-Existing Conditions</div>

        <table className={styles.lifestyleTable}>
          <tr>
            <th>Conditions</th>
            <th>For Self</th>
            <th>In Family</th>
          </tr>

          <tbody>
            {preexsitingconditons != null ? (
              Object.keys(preexsitingconditons).map((e, i) => {
                return (
                  <tr key={i}>
                    <td>{preexsitingconditons[e].condition}</td>
                    <td>
                      {preexsitingconditons[e].self
                        ? preexsitingconditons[e].self
                        : "NA"}
                    </td>
                    <td>
                      {preexsitingconditons[e].family
                        ? preexsitingconditons[e].family
                        : "NA"}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4}>
                  <div className="no-data">
                    <span>No data available</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* <div className="button-container">

        <button onClick={()=>{setActiveTop(2)}} className='submt-btn'>Save & proceed</button>
        <button className='join-btn'>JOIN CONSULTATION</button>

    </div> */}
    </div>
  );
};

export default Lifestyle;
